import React from 'react';
import Paragraph from './paragraph';
import convertCssUnit from './convert-css-unit';

export default function Headline({
  fontSize = convertCssUnit('2rem'),
  lineHeight = 1.25,
  fontWeight = 'bold',
  color = 'headline',
  ...props
}) {
  return (
    <Paragraph
      fontSize={fontSize}
      fontWeight={fontWeight}
      color={color}
      lineHeight={lineHeight}
      {...props}
    />
  );
}
